






















import { Component, Prop, Vue } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { FView } from '@/core/FView';
import { Place } from '@/core/data/company/Place';
import ClickOutside from 'vue-click-outside';
import { Common } from '@/core/Common';

@Component ({
  components: { VuePerfectScrollbar },
  directives: { ClickOutside },
})
export default class extends Vue {
    isOpened: boolean = false;

    getScrollSettings() {
        return Common.GetScrollSettings();
    }

    getSelected() {
        return FView.Get().dataManager.GetPlace();
    }

    isSelected(place: Place) {
        return place.company.id == this.getSelected().company.id &&
                place.name == this.getSelected().name;
    }

    getPlaceName() {
        return this.getSelected().getShortName();
    }

    getPlaces() {
        return FView.Get().dataManager.GetPlaces();
    }

    select(place: Place) {
        this.$emit("placeChanged", place);
    }

    toggleDropDown() {
        this.isOpened = !this.isOpened;

        if (this.isOpened) {
            this.$nextTick(() => {
                let container = this.$el.querySelector(".selector-list .ps") as HTMLDivElement;
                let selected = container.querySelector(".row[selected]") as HTMLDivElement;

                container.scrollTop = selected.offsetTop - container.clientHeight / 2;
            });
        }
    }

    hide() {
        if (this.isOpened) {
            this.isOpened = false;
        }
    }
}
